import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearStore } from '../../../store';
import {
  isLoggedInSelector,
  isAdminSelector,
  allDoctorsSelector,
  fetchNotificationSettingsAsync,
  fetchNotificationTemplatesAsync,
  fetchPharmaciesAsync,
  fetchPrimaryCaregiverAsync,
  fetchPrimaryDoctorAsync,
  fetchSpecialistsAsync,
  homeAddressesSelector,
  notificationSettingsSelector,
  notificationTemplatesSelector,
  pharmaciesSelector,
} from '../../../lib/dataLayer';
import { isPlatform } from '@ionic/core';
import BackgroundGeolocation from 'cordova-background-geolocation';
import PalliativeCareRoot from '../components/PalliativeCareRoot';
import { GEO_DEBUG } from '../../Geolocation/util';

import {
  getGeofences,
  meetsUserSettings,
} from '../../Geolocation/geofenceHelpers';

const mapStateToProps = state => {
  const doctors = allDoctorsSelector(state);
  const homeAddressesORIGINAL = homeAddressesSelector(state);
  const pharmaciesORIGINAL = pharmaciesSelector(state);
  const notificationSettings = notificationSettingsSelector(state);
  const notificationTemplates = notificationTemplatesSelector(state);

  const geofences = getGeofences({
    frequencyNotificationTemplates: notificationTemplates,
    doctors,
    homeAddresses: homeAddressesORIGINAL,
    pharmacies: pharmaciesORIGINAL,
  });

  return {
    isAdmin: isAdminSelector(state),
    isLoggedIn: isLoggedInSelector(state),
    geofences,
  };
};

const unmountBackgroundGeolocation = () => {
  GEO_DEBUG && console.log('*DTA unmountBackgroundGeolocation()');
  if (isPlatform('android') || isPlatform('ios')) {
    BackgroundGeolocation.removeListeners();
    BackgroundGeolocation.removeGeofences();
    BackgroundGeolocation.stop();
  }
};

const mapDispatchToProps = dispatch => {
  return {
    onLogout: () => {
      unmountBackgroundGeolocation();
      return dispatch(clearStore());
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PalliativeCareRoot),
);



// WEBPACK FOOTER //
// ./src/modules/App/containers/PalliativeCareRootContainer.js